import React, { useContext } from 'react'
import { AuthProvider } from '../contexts/Auth'
import { ApiDataWrapperProvider } from '../contexts/ApiDataWrapper'
import { ThemeModeContext, ThemeModeProvider } from '../contexts/ThemeMode'
import { ThemeProvider } from '@mui/material'

function ThemedShell({ children }) {
  const { theme } = useContext(ThemeModeContext)
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        {children}
      </AuthProvider>
    </ThemeProvider>
  )
}

export default function LayoutBase({ children }) {
  return (
    <ApiDataWrapperProvider>
      <ThemeModeProvider>
        <ThemedShell>{children}</ThemedShell>
      </ThemeModeProvider>
    </ApiDataWrapperProvider>
  )
}
